import { Controller } from "@hotwired/stimulus"

const SCROLL_LOCK_CLASS = "visitor-training-presentation-video-overlay-is-open"

// Dark overlay (native <dialog>) for the training presentation Instagram reel.
// Official Instagram embeds do not support a pause API (cross-origin iframe).
// Blanking the iframe on close is what actually stops playback.
export default class extends Controller {
  static targets = ["dialog", "source", "embed", "skeleton"]

  open (event) {
    event?.preventDefault()
    event?.stopPropagation()
    if (!this.hasDialogTarget || this.dialogTarget.open) return

    this.resetEmbed()
    this.dialogTarget.showModal()
    this.lockScroll()
  }

  closeOnBackdrop (event) {
    if (event.target === this.dialogTarget) this.close()
  }

  close (event) {
    event?.stopPropagation()
    if (!this.hasDialogTarget || !this.dialogTarget.open) return

    this.dialogTarget.close()
  }

  onDialogClose () {
    this.unlockScroll()
    this.stopPlayback()
    this.showSkeleton()
    if (this.hasEmbedTarget) this.embedTarget.replaceChildren()
  }

  disconnect () {
    this.unlockScroll()
    this.stopPlayback()
    if (this.hasDialogTarget && this.dialogTarget.open) this.dialogTarget.close()
  }

  lockScroll () {
    if (this.scrollLocked) return

    this.scrollLocked = true
    this.scrollY = window.scrollY
    document.documentElement.style.setProperty("--overlay-scroll-top", `-${this.scrollY}px`)
    document.documentElement.classList.add(SCROLL_LOCK_CLASS)
  }

  unlockScroll () {
    if (!this.scrollLocked) return

    this.scrollLocked = false
    document.documentElement.classList.remove(SCROLL_LOCK_CLASS)
    document.documentElement.style.removeProperty("--overlay-scroll-top")
    window.scrollTo(0, this.scrollY || 0)
  }

  stopPlayback () {
    if (!this.hasDialogTarget) return

    this.dialogTarget.querySelectorAll("iframe").forEach((iframe) => {
      iframe.src = "about:blank"
      iframe.remove()
    })
  }

  resetEmbed () {
    if (!this.hasSourceTarget || !this.hasEmbedTarget) return

    this.showSkeleton()
    this.embedTarget.replaceChildren(this.sourceTarget.content.cloneNode(true))
    this.bindEmbedLoad()
  }

  bindEmbedLoad () {
    const iframe = this.embedTarget.querySelector("iframe")
    if (!iframe) return

    iframe.addEventListener("load", () => this.hideSkeleton(), { once: true })
  }

  showSkeleton () {
    if (!this.hasSkeletonTarget) return

    this.skeletonTarget.hidden = false
  }

  hideSkeleton () {
    if (!this.hasSkeletonTarget) return

    this.skeletonTarget.hidden = true
  }
}
